module.exports = __webpack_public_path__ + "static/media/Platformicon01@2x.3ceb7135.png";